var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLorryIconGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.99 0a.985.985 0 00-.7.293C.104.48 0 .735 0 1v10c0 .265.104.52.29.707a.985.985 0 00.7.293h1.37a2.505 2.505 0 01.859-1.438 2.46 2.46 0 013.132 0c.442.365.746.873.86 1.438h1.287a.985.985 0 00.7-.293c.185-.187.29-.442.29-.707V1c0-.265-.105-.52-.29-.707a.985.985 0 00-.7-.293H.99zm11.22 3a.985.985 0 00-.7.293c-.186.187-.29.442-.29.707v6.05a2.451 2.451 0 011.86.364A2.488 2.488 0 0114.14 12h1.37a.985.985 0 00.7-.293c.186-.187.29-.442.29-.707V6c0-.265-.104-.52-.29-.707l-2.31-2A.985.985 0 0013.2 3h-.99z",
    fill: "#818181"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27 12.5c0 .398-.156.78-.434 1.06a1.477 1.477 0 01-2.1 0 1.508 1.508 0 010-2.12 1.477 1.477 0 012.1 0c.278.28.435.662.435 1.06zm6.93 0c0 .398-.156.78-.434 1.06a1.477 1.477 0 01-2.1 0 1.508 1.508 0 010-2.12 1.478 1.478 0 012.1 0c.278.28.435.662.435 1.06z",
    fill: "#818181"
  })));
}

export default SvgLorryIconGrey;